import { AbstractGameView } from "@lib/titan2-slingo/dist/game/view/abstract/display/AbstractGameView";
import { TitanSpine } from "@lib/titan2/dist/game/control/TitanSpine";
import { TitanText } from "@lib/titan2/dist/game/control/TitanText";
import { addToTitanSpineSlot, updateResponsiveSpineSlotsChildren } from "../../../utils/SpineUtils";
import { FreeSpinReelControllerEvent, GameEvent } from "../../../controller/event/GameEvent";
import { SpineUtil } from "@lib/titan2/dist/util/view/SpineUtil";
import { SlingoEvent, FreeSpinOverlayEvent } from "@lib/titan2-slingo/dist/game/controller/event/SlingoEvent";
import { GameStyle } from "../style/GameStyle";
import { CommonGameEvent } from "@lib/titan2/dist/game/controller/event/CommonGameEvent";
import { FeatureTransitionEvents } from "../../../controller/FeatureTransitionController";
import { DialogEvent } from "@lib/titan2/dist/game/manager/DialogManager";
import { Service } from "@lib/titan2-slingo/dist/api/Service";
export class GameFreeSpinsCounter extends AbstractGameView {
    create() {
        super.create();
        this.animation = TitanSpine.createSpine(this, this.landscapeProperties.animation, this.portraitProperties.animation);
        this.value = TitanText.createField(null, "free-spins-value", this.landscapeProperties.freeSpinsValue, this.portraitProperties.freeSpinsValue);
        addToTitanSpineSlot(this.animation, this.value, "dynamic-slot-number");
        this.value.setText("", true);
        this.interactive = true; // just to mouse-block things behind it
        this.close();
    }
    postCreate() {
        this.pendingFreeSpinRecovery = false;
        this.hidForDialog = false;
        this.collectedFreeSpins = 0;
        this.value.setTrackingId(GameStyle.REMAINING_FREE_SPINS);
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(GameEvent.FREE_SPIN_REELS_RECOVER, this.handleFreeSpinRecover);
        this.registerGame(FreeSpinReelControllerEvent.FREE_SPIN_TRANSITION_OUT_START, this.close);
        this.registerGame(FreeSpinReelControllerEvent.FREE_SPIN_GAME_OVER_TRANSITION_OUT_START, this.close);
        this.registerGame(SlingoEvent.REELS_START, this.handleReelsStart);
        this.registerGame(FreeSpinOverlayEvent.FREE_SPIN_END, this.handleFreeSpinAwardEnd);
        this.registerGame(CommonGameEvent.SPIN_REQUEST, this.handleSpinRequest);
        this.registerGame(FeatureTransitionEvents.TRANSITION_FEATURE_SELECTOR, this.close);
        this.registerGame(CommonGameEvent.GAME_OVER_CONFIRMED, this.close);
        this.registerGame(DialogEvent.ACTIVE, this.handleDialogActive);
        this.registerGame(DialogEvent.INACTIVE, this.handleDialogInactive);
        this.registerGame(CommonGameEvent.PURCHASE_ENTRY, this.handlePurchaseEntry);
        this.visible = false;
    }
    handlePurchaseEntry() {
        this.visible = false;
        this.pendingFreeSpinRecovery = false;
        this.hidForDialog = false;
        this.collectedFreeSpins = 0;
    }
    handleDialogActive() {
        if (this.visible) {
            this.visible = false;
            this.hidForDialog = true;
        }
    }
    handleDialogInactive() {
        if (this.hidForDialog && this.model.getState().isChooseCell()) {
            this.visible = true;
            this.hidForDialog = false;
        }
    }
    open() {
        const dialogOpen = this.factory.getDialogManager().isMessageDialogOpen();
        if (dialogOpen) {
            this.hidForDialog = true;
        }
        this.interactive = !Service.isReplay(); // just to mouse-block things behind it
        this.visible = !dialogOpen;
        SpineUtil.play(this.animation, "freeSpinsCounterIntro", () => {
            SpineUtil.playLoop(this.animation, "freeSpinsCounterIdle");
        });
        this.animation.getSpine().update(0.001);
    }
    close() {
        if (this.visible) {
            SpineUtil.play(this.animation, "freeSpinsCounterOutro", () => {
                this.visible = false;
            });
        }
    }
    react() {
        SpineUtil.play(this.animation, "freeSpinsCounterReact", () => {
            SpineUtil.playLoop(this.animation, "freeSpinsCounterIdle");
        });
    }
    handleFreeSpinRecover() {
        this.pendingFreeSpinRecovery = true;
        this.collectedFreeSpins = this.model.getGameProgress().getFreeSpinsRemaining();
        if (this.model.isChooseCell()) {
            this.collectedFreeSpins -= this.model.getSpinResult().getReelSequence().getFreeSpinIndexes().length;
            this.open();
        }
        else {
            this.pendingFreeSpinRecovery = true;
        }
        this.updateFreeSpinsRemaining();
    }
    handleSpinRequest() {
        if (this.pendingFreeSpinRecovery || (this.hidForDialog && !this.model.getState().isChooseCell())) {
            this.pendingFreeSpinRecovery = false;
            this.hidForDialog = false;
            if (this.model.getGameProgress().getFreeSpinsRemaining() > 0) {
                this.open();
            }
        }
    }
    handleReelsStart() {
        this.collectedFreeSpins = Math.max(0, this.collectedFreeSpins - 1);
        this.updateFreeSpinsRemaining();
    }
    handleFreeSpinAwardEnd() {
        if (this.visible) {
            this.react();
        }
        else {
            this.open();
        }
        this.collectedFreeSpins++;
        this.updateFreeSpinsRemaining();
    }
    updateFreeSpinsRemaining() {
        const currentlyDisplayedValue = parseInt(this.value.getText());
        if (currentlyDisplayedValue === this.collectedFreeSpins) {
            return;
        }
        this.value.setText(String(this.collectedFreeSpins));
    }
    handleRotate(event) {
        super.handleRotate(event);
        updateResponsiveSpineSlotsChildren(this.animation, "dynamic-slot-number");
    }
}
//# sourceMappingURL=GameFreeSpinsCounter.js.map